import { TFunction } from 'i18next';

import { PaymentDeviceAccessory } from '@/models/common/PaymentDeviceEnums';

/** Every accessory, in the order the office lists them (and the server stores them). */
export const ALL_ACCESSORIES: PaymentDeviceAccessory[] = [
  PaymentDeviceAccessory.Case,
  PaymentDeviceAccessory.Wallet,
  PaymentDeviceAccessory.ChargerHead,
  PaymentDeviceAccessory.Cable,
];

/** The list in the canonical order, without duplicates. */
export const sortAccessories = (items: PaymentDeviceAccessory[] | null | undefined): PaymentDeviceAccessory[] =>
  ALL_ACCESSORIES.filter((item) => (items ?? []).includes(item));

/** What went out and is not in what came back. */
export const missingAccessories = (
  handedOver: PaymentDeviceAccessory[] | null | undefined,
  returned: PaymentDeviceAccessory[] | null | undefined,
): PaymentDeviceAccessory[] => sortAccessories(handedOver).filter((item) => !(returned ?? []).includes(item));

/** Adds or removes one item, keeping the canonical order. */
export const toggleAccessory = (items: PaymentDeviceAccessory[], item: PaymentDeviceAccessory, on: boolean): PaymentDeviceAccessory[] =>
  sortAccessories(on ? [...items, item] : items.filter((existing) => existing !== item));

/** "נרתיק, כבל" */
export const accessoriesText = (items: PaymentDeviceAccessory[] | null | undefined, t: TFunction): string =>
  sortAccessories(items).map((item) => t(`paymentDevices.accessories.${item}`)).join(', ');
